import { render } from "./search-icon.vue.js?vue&type=template&id=5b530c61!=!../../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./search-icon.vue?vue&type=template&id=5b530c61"
const script = {}

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__